import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { AccountsPage } from '../pages/accounts/accounts';
import { PlansPage } from '../pages/plans/plans';
import { PlanPage } from '../pages/plans/plans';
import { MenusPage } from '../pages/menus/menus';
import { CountersPage } from '../pages/menus/counters';
import { CounterViewPage } from '../pages/menus/counters';
import { MenuSemanalPage } from '../pages/menus/menus';
import { MenuDiarioPage } from '../pages/menus/menus';
import { CustomersPage } from '../pages/customers/customers';
import { CustomerPage } from '../pages/customers/customer';
import { FoodsPage } from '../pages/foods/foods';
import { FoodPage } from '../pages/foods/foods';
import { CancellationsPage } from '../pages/cancellations/cancellations';
import { CancellatePage } from '../pages/cancellations/cancellate';
import { SelectDaysPage } from '../pages/cancellations/cancellate';
import { DaysPage } from '../pages/days/days';
import { IncidentsPage } from '../pages/incidents/incidents';
import { ModalViewIncidentPage } from '../pages/incidents/incidents';
import { NewIncidentPage } from '../pages/incidents/create';
import { ModalNewIncidentPage } from '../pages/incidents/create';
import { ChecksPage } from '../pages/customers/checks/checks';
import { RestrictionsPage } from '../pages/customers/restrictions/restrictions';
import { RestrictionPage } from '../pages/customers/restrictions/restrictions';
import { RecipesPage } from '../pages/recipes/recipes';
import { RecipePage } from '../pages/recipes/recipes';
import { IngredientPage } from '../pages/ingredients/ingredients';
import { IngredientsPage } from '../pages/ingredients/ingredients';
import { GroupIngredientsPage } from '../pages/ingredients/groupingredients';
import { GroupIngredientPage } from '../pages/ingredients/groupingredients';
import { FindRecipePage } from '../pages/menus/findrecipe';
import { addIngredient } from '../pages/recipes/addIngredient';
import { FindIngredientPage } from '../pages/recipes/addIngredient';
import { ManualTagsPage } from '../pages/menus/manualtag/manualtag';
import { RoutesPage } from '../pages/routes/routes';
import { ChangesPage } from '../pages/changes/changes';
import { MenuFoodsPage } from '../pages/days/menu-foods/menu-foods';
import { MenuCustomersPage } from '../pages/days/menu-customers/menu-customers';
import { ModalDetailPage } from '../pages/days/modal-detail/modal-detail';
import { ModalRecipesPage } from '../pages/days/modal-recipes/modal-recipes';
import { InventoryPage } from '../pages/inventory/inventory';
import { StockPage } from '../pages/inventory/stock/stock';
import { MovementsPage } from '../pages/inventory/movements/movements';
import { OutputPage } from '../pages/inventory/output/output';
import { PaymentsPage } from '../pages/pay/payments/payments';
import { ChargesPage } from '../pages/pay/charges/charges';
import { PayPage } from '../pages/pay/pay';
import { OrdersPage } from '../pages/pay/orders/orders';
import { CustomerMenuPage } from '../pages/customers/customer-menu/customer-menu';
import { BalancePage } from '../pages/customers/balance/balance';
import { LocationPage } from '../pages/customers/location/location';
import { MonthSelectorModal } from '../pages/customers/month-selector-modal/month-selector-modal';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';


import { DragulaModule } from 'ng2-dragula';

import { CsvService } from "angular2-json2csv";
import { RouteMapPage } from "../pages/routes/map";
import { CustomerHistoryPage } from "../pages/home/customer-history/customer-history";
import { NotificationsProvider } from '../providers/notifications/notifications';
import { ChangesTypeformPage } from "../pages/changes/typeform/typeform";
import { RequestsPage } from "../pages/changes/requests/requests";
import { AddRequestPage } from "../pages/changes/requests/add/add";
import { ActionRequestsPage } from "../pages/changes/requests/action/action";
import { RequestsExecutionProvider } from '../providers/requests-execution/requests-execution';
import { BeetrackProvider } from '../providers/beetrack/beetrack';
import { FoodsProvider } from '../providers/foods/foods';
import * as firebase from 'firebase/app';
import { GlobalProvider } from '../providers/global/global';
import { FindCustomerComponent } from '../components/find-customer/find-customer';
import { environment } from '../environments/environment';

firebase.initializeApp(environment.firebase);

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    HomePage,
    AccountsPage,
    PlansPage,
    PlanPage,
    CustomersPage,
    CustomerPage,
    FoodsPage,
    FoodPage,
    MonthSelectorModal,
    MenusPage,
    MenuDiarioPage,
    MenuSemanalPage,
    CancellationsPage,
    CancellatePage,
    SelectDaysPage,
    IncidentsPage,
    NewIncidentPage,
    ModalNewIncidentPage,
    ModalViewIncidentPage,
    ChecksPage,
    RecipePage,
    RecipesPage,
    FindRecipePage,
    IngredientPage,
    IngredientsPage,
    GroupIngredientsPage,
    GroupIngredientPage,
    addIngredient,
    FindIngredientPage,
    RestrictionsPage,
    RestrictionPage,
    CountersPage,
    CounterViewPage,
    ManualTagsPage,
    RoutesPage,
    RouteMapPage,
    ChangesPage,
    ChangesTypeformPage,
    RequestsPage,
    AddRequestPage,
    ActionRequestsPage,
    CustomerHistoryPage,
    DaysPage,
    MenuFoodsPage,
    MenuCustomersPage,
    ModalDetailPage,
    ModalRecipesPage,
    InventoryPage,
    MovementsPage,
    OutputPage,
    StockPage,
    PaymentsPage,
    ChargesPage,
    PayPage,
    FindCustomerComponent,
    OrdersPage,
    CustomerMenuPage,
    BalancePage,
    LocationPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    }),
    DragulaModule.forRoot(),
    HttpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    HomePage,
    AccountsPage,
    PlansPage,
    PlanPage,
    CustomersPage,
    CustomerPage,
    FoodsPage,
    FoodPage,
    MenusPage,
    MenuDiarioPage,
    MenuSemanalPage,
    CancellationsPage,
    MonthSelectorModal,
    CancellatePage,
    SelectDaysPage,
    IncidentsPage,
    NewIncidentPage,
    ModalNewIncidentPage,
    ModalViewIncidentPage,
    ChecksPage,
    RecipePage,
    RecipesPage,
    FindRecipePage,
    IngredientPage,
    IngredientsPage,
    GroupIngredientsPage,
    GroupIngredientPage,
    addIngredient,
    FindIngredientPage,
    RestrictionsPage,
    RestrictionPage,
    CountersPage,
    CounterViewPage,
    ManualTagsPage,
    RoutesPage,
    RouteMapPage,
    ChangesPage,
    ChangesTypeformPage,
    RequestsPage,
    AddRequestPage,
    ActionRequestsPage,
    CustomerHistoryPage,
    DaysPage,
    MenuFoodsPage,
    MenuCustomersPage,
    ModalDetailPage,
    ModalRecipesPage,
    InventoryPage,
    MovementsPage,
    OutputPage,
    StockPage,
    PaymentsPage,
    ChargesPage,
    PayPage,
    FindCustomerComponent,
    OrdersPage,
    CustomerMenuPage,
    BalancePage,
    LocationPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    CsvService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    NotificationsProvider,
    RequestsExecutionProvider,
    BeetrackProvider,
    FoodsProvider,
    GlobalProvider
  ]
})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts